import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { DialogContentText, Button } from '@material-ui/core';
import { uniqueId } from 'lodash';

/**
 * A reusable error dialog component that displays detailed error messages.
 *
 * @param {Object} props - Component props
 * @param {string} props.errorMsg - The error message to display (can include newlines for detailed errors)
 * @param {Function} props.setErrorMsg - Function to update the error message state (pass undefined to close)
 * @param {string} props.title - The title of the error dialog
 * @param {string} props.closeButtonText - Text for the close button (defaults to "Close")
 * @returns {JSX.Element} Error dialog component
 */
const ErrorDialog = ({ errorMsg, setErrorMsg, title = 'Error', closeButtonText = 'Close' }) => {
    return (
        <Dialog open={errorMsg != null} fullWidth maxWidth="sm">
            <DialogTitle id="draggable-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <div>
                        {errorMsg && errorMsg?.split('\n')[0]}
                        {errorMsg && errorMsg.includes('\n') && (
                            <ul key={uniqueId()}>
                                {errorMsg
                                    ?.split('\n')
                                    ?.filter((errorArg, index) => errorArg !== '' && index !== 0)
                                    ?.map((errorArg) => {
                                        return <li key={uniqueId()}>{errorArg}</li>;
                                    })}
                            </ul>
                        )}
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setErrorMsg(undefined)} color="primary">
                    {closeButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorDialog;
